






































































export default {
  props: {
    clientId: String
  },
  data: function() {
    return {
      user: {
        correlation: '',
        name: '',
        team: '',
        email: ''
      },
      loading: false,
      teams: []
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .ListTeams()
      .then(results => (this.teams = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    saveUser() {
      this.$api.clientAdmin
        .CreateUser(this.user)
        .then(() => this.$router.push({ name: 'settings-users-list' }))
    }
  }
}
